
export function toggleDrawer(open = false) {
  return {
    type: "APP_DRAWER",
    open,
  }
}
